import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import './iamExplorer.css';

class IamExplorer extends Component {

  state = {

  };

  componentDidMount() {

  };

  render() {

    return (
      <div className="IamExplorerPage">
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <p>-----------------<Link to="/iamExplorer/actions">IAM Actions</Link></p>
        <p>-----------------<Link to="/iamExplorer/users">IAM Users</Link></p>
        <p>-----------------<Link to="/iamExplorer/keys">IAM Keys</Link></p>
      </div>
    );
  };

};

export default IamExplorer;


// WEBPACK FOOTER //
// ./src/components/content/iamExplorer/iamExplorer.js